module.exports = __webpack_public_path__ + "img/gb13871-92-32x47x8.prt.aa056d7a.jpg";